import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button
} from "@mui/material";
import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { PATHS } from "../../utils/constant";
import { NotificationContext } from "../../contexts/NotificationContext";
import { AuthContext } from "../../contexts/AuthContext";
import VerifyOtp from "./VerifyOtp";
import { sendOtp as sendOtpService, login } from "../../services/Auth";
import useService from "../../hooks/useService";

const CenterContent = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    /* background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */
    background: var(--secondary_color);
  `;

const CenterRow = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 400px;
  `;

const InputFieldContainer = styled.div`
    margin-bottom: 20px;
    width: 100%;
  `;

const LoginButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
  `;

const LoginCard = styled(Card)`
    width: 100%;
    border-radius: 4px;
    min-height: 300px;
    `;

const StyledCardContent = styled(CardContent)`
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    gap: 40px;
    padding: 20px !important;
    height: 100%;
  `;

const Logo = styled.img`
    height: 100px;
    margin-bottom: 10px;
  `;

const HeaderContainer = styled.div`
    margin-bottom: 20px;
  `;

const StyledForgotPassword = styled(Typography)`
  cursor:pointer;
  `

const StyledHeading = styled(Typography)`
  font-weight:bold;
  `

const Login = () => {
  const [phone, setPhone] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const { notify } = useContext(NotificationContext)
  const [validityTime, setValidityTime] = useState(30000);
  const [resendOtpReqCount, setResendOtpReqCount] = useState(1);
  const [isResendOtp, setIsResendOtp] = useState(false);
  const { execute } = useService()

  //set validated mobile number given by customers
  const handlePhoneChange = (value: string) => {
    const onlyNums = value.replace(/[^0-9]/g, ''); // validate mobile number.allow only digits
    if (onlyNums.length <= 10) {
      setPhone(onlyNums) // set mobile number only if it's less than or equal to 10;
    }
  }

  const onValidityExpire = () => {
    console.log('onValidityExpire...')
    setIsResendOtp(true);
    setValidityTime(resendOtpReqCount >= 3 ? 180000 : 30000);//set timer of 1 min upto 3 count else timer of 3 min
    setResendOtpReqCount(resendOtpReqCount + 1);//increment count on request of calling function
    if (resendOtpReqCount === 5) setIsResendOtp(false);
  }

  const sendOtp = (phone:string) => {
    return execute(() => sendOtpService(phone));
  }
  
  const verifyOtp = (phone:string, otp:string) => {
    return execute(() => login({otp, phone}));
  }

  const submitHandler = async () => {
    if (phone.length < 10) return notify('Please enter a valid Mobile Number!', 'error')
    const { error } = await sendOtp(phone)

    if (error !== null) {
      // notify(error.message, 'error')
    }
    else {
      notify('OTP Sent.')
      setOtpSent(true)
      setIsResendOtp(false)
      setValidityTime(resendOtpReqCount >= 3 ? 180000 : 30000);

    }
  }

  const renderLoginCard = () => {
    return (
      <LoginCard raised>
        <StyledCardContent>
          <HeaderContainer>
            <StyledHeading variant="h5" align="center">
              LOGIN
            </StyledHeading>
          </HeaderContainer>
          {!otpSent
            ?
            <>
              <InputFieldContainer>
                <TextField
                  fullWidth={true}
                  label="Mobile Number"
                  placeholder="9988000000"
                  variant="outlined"
                  value={phone}
                  onChange={(e) => handlePhoneChange(e.target.value)}
                  onKeyDown={(e) => {
                    if (e && e.key && e.key === "Enter") {
                      submitHandler();
                    }
                  }}
                />
              </InputFieldContainer>
              <LoginButtonContainer>
                <Button disabled={phone.length < 10} onClick={submitHandler} size="large" variant="contained" color="primary">
                  Send Otp
                </Button>
              </LoginButtonContainer>
            </>
            :
            <VerifyOtp
              isResendOtp={isResendOtp}
              onValidityExpire={onValidityExpire}
              phone={phone}
              email={''}
              setIsResendOtp={setIsResendOtp}
              validityTime={validityTime}
              verifyOTPService={verifyOtp}
              sendOTPService={sendOtp}
            />}
        </StyledCardContent>
      </LoginCard>
    );
  };

  const renderLogo = () => {
    return <Logo src="./assets/icons/MMTC-PAMP-Logo-New.png" />;
  };

  return (
    <CenterContent>
      <CenterRow>
        {renderLogo()}
        {renderLoginCard()}
      </CenterRow>
    </CenterContent>
  );
};

export default Login;
